import type { SkillConflict } from '@gitlab-org/ai-context/node';
import type { SkillConflictView } from '@gitlab-org/tui';

export function toSkillConflictViews(conflicts: SkillConflict[]): SkillConflictView[] {
  return conflicts.map((conflict) => ({
    skillName: conflict.skillName,
    winner: {
      path: conflict.winner.displayPath,
      sourceLabel: conflict.winner.source,
    },
    losers: conflict.losers.map((loser) => ({
      path: loser.displayPath,
      sourceLabel: loser.source,
    })),
  }));
}
